import { lazy } from "react";
import GuestGuard from "utils/route-guard/GuestGuard";
import MinimalLayout from "layout/MinimalLayout";
import NavMotion from "layout/NavMotion";
import Loadable from "ui-component/Loadable";

let AuthLogin;
let AuthRegister;

const LOCAL_TEST_BRAND = "demo";
const hostname = typeof window !== "undefined" ? window.location.hostname : "";
const isLocalhost = hostname.includes("localhost");

let subdomain = "";
if (!isLocalhost) {
  subdomain = hostname.split(".").length > 2 ? hostname.split(".")[0] : "";
} else {
  subdomain = LOCAL_TEST_BRAND;
}
console.log(subdomain, 'siub')

if (subdomain === "soi") {
  AuthLogin = Loadable(
    lazy(() => import("views/pages/authentication/authentication2/SOILogin"))
  );
  AuthRegister = Loadable(
    lazy(() =>
      import("views/pages/authentication/authentication1/RegistrationByAlumniSOI")
    )
  );
} else if (subdomain === "ssvm") {
  AuthLogin = Loadable(
    lazy(() => import("views/pages/authentication/authentication2/SSVMLogin"))
  );
  AuthRegister = Loadable(
    lazy(() =>
      import("views/pages/authentication/authentication1/RegistrationBySSVM")
    )
  );
} else if (subdomain === "ustm") {
  AuthLogin = Loadable(
    lazy(() => import("views/pages/authentication/authentication2/USTMLogin"))
  );
  AuthRegister = Loadable(
    lazy(() =>
      import("views/pages/authentication/authentication1/RegistrationByAlumniUSTM")
    )
  );
} else if (subdomain === "msdgs") {
  AuthLogin = Loadable(
    lazy(() => import("views/pages/authentication/authentication2/MsDhoniLogin"))
  );
  AuthRegister = Loadable(
    lazy(() =>
      import("views/pages/authentication/authentication1/RegistrationByAlumniMsDhoni")
    )
  );
} else if (subdomain === "nhs") {
  AuthLogin = Loadable(
    lazy(() => import("views/pages/authentication/authentication2/NHPSLogin"))
  );
  AuthRegister = Loadable(
    lazy(() =>
      import("views/pages/authentication/authentication1/RegistrationByNHS")
    )
  );
} else if (subdomain == 'vvp') {
  AuthLogin = Loadable(
    lazy(() => import("views/pages/authentication/authentication1/Login1"))
  );
  AuthRegister = Loadable(
    lazy(() =>
      import("views/pages/authentication/authentication1/RegistrationByAlumni")
    )
  );
}
else {
  AuthLogin = Loadable(
    lazy(() => import("views/pages/authentication/authentication1/Login1"))
  );
  AuthRegister = Loadable(
    lazy(() =>
      import("views/pages/authentication/authentication1/RegistrationByAlumni")
    )
  );
}

// login routing
// const AuthLogin = Loadable(
//   lazy(() => import("views/pages/authentication/authentication1/Login1"))
// );
// const AuthLogin = Loadable(
//   lazy(() => import("views/pages/authentication/authentication2/NHPSLogin"))
// );
// const AuthLogin = Loadable(
//   lazy(() => import("views/pages/authentication/authentication2/SOILogin"))
// );
// const AuthLogin = Loadable(
//   lazy(() => import("views/pages/authentication/authentication2/MsDhoniLogin"))
// );
// const AuthLogin = Loadable(
//   lazy(() => import("views/pages/authentication/authentication2/USTMLogin"))
// );
// const AuthLogin = Loadable(
//   lazy(() => import("views/pages/authentication/authentication2/SSVMLogin"))
// );
// const AuthRegister = Loadable(
//   lazy(() => import("views/application/register/RegistrationForm"))
// );
// const AuthRegister = Loadable(
//   lazy(() => import("views/pages/authentication/authentication1/Register1"))
// );
// const AuthRegister = Loadable(
//   lazy(() =>
//     import("views/pages/authentication/authentication1/RegistrationBySSVM")
//   )
// );

// const AuthRegister = Loadable(
//   lazy(() => import("views/application/register/RegistrationForm"))
// );
// const RegistrationByAlumni = Loadable(
//   lazy(() =>
//     import("views/pages/authentication/authentication1/RegistrationByAlumni")
//   )
// );
// const RegistrationByAlumni = Loadable(
//   lazy(() =>
//     import("views/pages/authentication/authentication1/RegistrationBySSVM")
//   )
// );
const RegistrationByAlumniSOI = Loadable(
  lazy(() =>
    import("views/pages/authentication/authentication1/RegistrationByAlumniSOI")
  )
);
// const RegistrationByAlumni = Loadable(
//   lazy(() =>
//     import("views/pages/authentication/authentication1/RegistrationByAlumniMsDhoni")
//   )
// );
// const RegistrationByAlumni = Loadable(
//   lazy(() =>
//     import("views/pages/authentication/authentication1/RegistrationByAlumni")
//   )
// );
// const RegistrationByInvitationLink = Loadable(
//   lazy(() =>
//     import(
//       "views/pages/authentication/authentication1/RegistrationByInvitationLink"
//     )
//   )
// );
// const RegistrationByInvitationLink = Loadable(
//   lazy(() =>
//     import(
//       "views/pages/authentication/authentication1/3"
//     )
//   )
// );
const RegistrationByInvitationLink = Loadable(
  lazy(() =>
    import("views/pages/authentication/authentication1/RegistrationInviteLinkSOI")
  )
);
// const RegistrationByAlumni = Loadable(
//   lazy(() =>
//     import("views/pages/authentication/authentication1/RegistrationByAlumniUSTM")
//   )
// );
const AuthForgotPassword = Loadable(
  lazy(() =>
    import("views/pages/authentication/authentication1/ForgotPassword1")
  )
);
const Otp = Loadable(
  lazy(() => import("views/application/register/OtpforEmail"))
);
const OTPVerify = Loadable(
  lazy(() => import("views/application/register/OTPverifyForgetPassword"))
);
const LinkedinProfile = Loadable(lazy(() => import("views/alumniRegistration/alumniProfile/LinkedinProfile")))

const GoggleOAuthProfile = Loadable(lazy(() => import("views/alumniRegistration/alumniProfile/GoggleProfile")))
const AuthRedirections = Loadable(lazy(() => import("views/redirect/AuthRedirection")))

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: "/",
  element: (
    <NavMotion>
      <GuestGuard>
        <MinimalLayout />
      </GuestGuard>
    </NavMotion>
  ),
  children: [
    {
      path: "/login",
      element: <AuthLogin />,
    },
    // {
    //   path: "/register",
    //   element: <AuthRegister />,
    // },
    {
      path: "/alumni/register/:id",
      element: <AuthRegister />,
    },
    {
      path: "/soi/alumni/register/:id",
      element: <RegistrationByAlumniSOI />,
    },
    {
      path: "/invite/:alumniId/:instituteId",
      element: <RegistrationByInvitationLink />,
    },
    {
      path: "/forgot",
      element: <AuthForgotPassword />,
    },
    {
      path: "/otp/page/:userName",
      element: <Otp />,
    },
    {
      path: "/verfiy/otp/:userName/:code",
      element: <OTPVerify />,
    },
    {
      path: "/linkedinprofile",
      element: <LinkedinProfile />,
    },
    {
      path: "/googleOauthProfile",
      element: <GoggleOAuthProfile />,
    },
    {
      path: "/auth/redirect",
      element: <AuthRedirections />,
    }
  ],
};

export default LoginRoutes;
